<template>
  <section class="d-flex flex-column align-items-center text-center w-100 h-100">
    <div class="d-flex justify-content-center align-items-end mb-3 w-100 h-100">
      <LogoEkco />
    </div>
    <div class="loading d-flex flex-column h-100">
      <Transition name="slide-up" mode="out-in">
        <article v-if="!errorMessage" class="d-flex flex-column">
          <AsciiSpinner class="fs-5" />
          <p class="m-0">{{ loadingMessage }}</p>
        </article>
        <article v-else class="d-flex flex-column justify-content-center text-start mx-3 mb-3">
          <ErrorMessageAlert :error-message="errorMessage" />
          <div class="d-flex ms-auto">
            <BootstrapButton
              v-if="authenticated"
              name="contact-support"
              variant="ghost"
              size="sm"
              @click="$emit('contact')"
            >
              {{ translate(language, 'Contact support') }}
            </BootstrapButton>
            <a
              v-else
              class="btn btn-sm btn-ghost"
              role="button"
              name="contact-support"
              href="mailto:sdnl@ek.co"
              style="user-select: text"
            >
              {{ translate(language, 'Contact support') }} (sdnl@ek.co)
            </a>
            <BootstrapButton name="logout" variant="ghost" size="sm" @click="$emit('logout')">
              {{ translate(language, 'Log out') }}
            </BootstrapButton>
          </div>
        </article>
      </Transition>
    </div>
  </section>
</template>
<script lang="ts" setup>
import {translate} from '@/translate';
/**
 * N.B. This component handles unauthenticated MSAL errors.
 *
 * 99% of our code is written with the assumption that the user is logged in.
 * This component should be as self-contained as possible, since any code it
 * were to load may currently be, or in the future become incompatible with
 * the unauthenticated state.
 *
 * Avoid referencing complicated code from here. This includes Pinia stores & any Vue
 * component that references those (or is likely to in the future).
 */
defineProps<{
  loadingMessage?: string;
  errorMessage?: string;
  authenticated: boolean;
}>();
defineEmits<{contact: []; logout: []}>();
const userSettingsStore = useUserSettingsStore();
const language = computed(() => userSettingsStore.userSettings.language);
</script>
<style lang="scss" scoped>
section {
  transition: all 0.25s ease;
}

:deep(.logo-ekco) {
  height: 6rem !important;
}

.loading {
  width: 100%;
}

@media (width >= 992px) {
  .loading {
    width: 48rem;
  }
}

.slide-up-enter-active,
.slide-up-leave-active {
  transition: all 0.25s ease-out;
}

.slide-up-enter-from {
  opacity: 0;
  transform: translateY(1rem);
}

.slide-up-leave-to {
  opacity: 0;
}
</style>
